<template>
  <div />
</template>

<script>
export default {
  name: 'UserIdentify',
  async mounted() {
    const user = await this.$auth.getUser();

    window.analytics.identify(user.id, {
      email: user.email,
      familyName: user.familyName,
      givenName: user.givenName,
      picture: user.picture,
    })
  }
}
</script>
